import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgTemplateOutlet } from '@angular/common';
import type { MetricItem, ReportBlock } from '#models';
import { ReusableChartComponent } from '#components';
import { parseTooltipHtml } from '../../mappers/tooltip-html.parser';
import { isComparisonHistoryChart } from '../../mappers/graph-block.mapper';

@Component({
  selector: 'app-detail-summary-blocks',
  imports: [NgTemplateOutlet, ReusableChartComponent],
  templateUrl: './detail-summary-blocks.component.html',
  styleUrl: './detail-summary-blocks.component.scss',
})
export class DetailSummaryBlocksComponent {
  private _sanitizer = inject(DomSanitizer);

  blocks = input<ReportBlock[] | null>(null);
  wrapTables = input<boolean>(false);

  safeBlocks = computed(() => (this.blocks() ?? [])
    .filter(block => block.type !== 'graph' || !isComparisonHistoryChart(block.graph.title)));

  safeHtml(raw: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(parseTooltipHtml(raw));
  }

  metricLabel(metric: MetricItem): SafeHtml {
    const raw = metric.tt ? `{{tt:${metric.label}|${metric.tt}}}` : metric.label;
    return this.safeHtml(raw);
  }
}
